<app-banner></app-banner> <app-introduce></app-introduce>
<app-course-categories></app-course-categories>
<app-courses></app-courses>
<app-testimonials></app-testimonials>
<app-footer-landing></app-footer-landing>
